export default "https://static.wmbcdn.com/uniweb/images/ad-banner.png";